import { useRef } from 'react';

import { RenderContent } from '@core/components/display/html/RenderContent';
import useGhostAssetPages from '@research-api/hooks/useGhostAssetPages';
import { GhostPostOrPage } from '@research-api/utils/api/ghost/ghost-interfaces';
import formatList from '@research-api/utils/functions/formatList';

type PriceAboutDetailProps = {
    code: string;
    hidePageTitle?: boolean;
};

const PriceAboutDetail = (props: PriceAboutDetailProps) => {
    const { code, hidePageTitle } = props;
    const { assetPages: overviewPages } = useGhostAssetPages(code, 'about');
    const deepDiveRef = useRef<HTMLDivElement>(null);

    if (!overviewPages || overviewPages.length === 0) {
        return null;
    }

    return (
        <div ref={deepDiveRef} className="flex flex-col border-t p-8 pt-0">
            {overviewPages.map((item: GhostPostOrPage, index: number) => (
                <div key={index}>
                    {!hidePageTitle && (
                        <h3 className="truncate text-xl font-headline pt-8 pb-4 leading-9">
                            {formatList(item?.title)}
                        </h3>
                    )}
                    <RenderContent html={overviewPages[index]!.html} fullWidth />
                </div>
            ))}
        </div>
    );
};

export default PriceAboutDetail;
